import { Action, createReducer, on } from '@ngrx/store';
import * as MedReviewActions from '../actions/med-review.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { BaseModel, QueryParamsModel } from '../../../../core/_base/crud';
import { loadBamboohealthCheckFailure } from '../actions/med-review.actions';

export const medReviewFeatureKey = 'medReview';
export class MedReviewModel extends BaseModel {
  id: number;
  patient_id: number;
  position: number;
}
export interface State extends EntityState<MedReviewModel> {
  loading: boolean;
  actionsLoading: boolean;
  totalCount: any;
  error: any;
  lastQuery;
  showInitWaitingMessage: boolean;
  bambooHealthData: any;
  bambooHealthError: any;
}

export const adapter: EntityAdapter<MedReviewModel> = createEntityAdapter<MedReviewModel>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  error: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedDoctorId: undefined,
  showInitWaitingMessage: true,
  bambooHealthData: {},
  bambooHealthError: null,
});

const medReviewReducer = createReducer(
  initialState,

  on(MedReviewActions.loadMedReviews, (state) => {
    return { ...state, loading: true };
  }),
  on(MedReviewActions.loadMedReviewsSuccess, (state, action: any) => {
    return adapter.addAll(action.data, {
      ...initialState,
      totalCount: action.count,
      lastQuery: {},
      loading: false,
      showInitWaitingMessage: false,
    });
  }),
  on(MedReviewActions.loadBamboohealthCheckSuccess, (state, action) =>{
    return {
      ...state,
    bambooHealthData: action.data
    }
  }),
  on(loadBamboohealthCheckFailure, (state, { error }) => ({
    ...state,
    bambooHealthError: error,
  })),
  on(MedReviewActions.loadMedReviewsFailure, (state) => state),
  on(MedReviewActions.clearMedReviews, () => initialState),
);

export function reducer(state: State | undefined, action: Action) {
  return medReviewReducer(state, action);
}
